import type { RouteRecordRaw } from 'vue-router';

export const analyticsRoutes = [
  {
    path: 'analytics',
    name: 'analytics',
    component: () => import('./AnalyticsPage.vue'),
    meta: { title: 'Analytics' },
  },
] as const satisfies readonly RouteRecordRaw[];
